module.exports = __webpack_public_path__ + "img/icon-recharge-card.6aab2684.svg";